import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToggleSwitch } from "../molecule/ToggleSwitch";
import { StandardButton } from "../atoms/buttons";




pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


export const PDFPreview = ({ docId, fileUrl, style, setSelectedPages, selectedPages, handleSave }) => {
    const [numPages, setNumPages] = useState(null);
    const [containerWidth, setContainerWidth] = useState(null);
    const containerRef = useRef(null);

    const updateWidth = useCallback(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.clientWidth);
        }
    }, []);

    useEffect(() => {
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, [updateWidth]);


    const togglePageSelection = (pageNumber) => {
        console.log("selecting page:", selectedPages);
        if (!docId) return;
        const updated = selectedPages.includes(pageNumber)
            ? selectedPages.filter(n => n !== pageNumber)
            : [...selectedPages, pageNumber];

        setSelectedPages(updated);
    };

    const handleSelectAll = () => {
        if (numPages) {
            const updated = selectedPages.length === numPages
                ? []
                : Array.from({ length: numPages }, (_, i) => i + 1);
            setSelectedPages(updated);
        }
    };

    return (
        <div className="pdf-preview-wrapper" style={{ ...style }}>
            <div className="pdf-toolbar">
                <ToggleSwitch checked={numPages && selectedPages.length === numPages} onChange={handleSelectAll} rightTitle="Selecteer alles" />
                {selectedPages.length > 0 && (
                    <div className="pdf-toolbar-selection">
                        Geselecteerde pagina's:{' '}
                        <strong>
                            {numPages && selectedPages.length === numPages ? 'Alle' : selectedPages.sort((a, b) => a - b).join(', ')}
                        </strong>
                    </div>
                )}
            </div>

            <div
                className="pdf-preview-container"
                ref={containerRef}
                style={{ overflowY: 'auto', overflowX: 'hidden', flexGrow: 1, padding: '1rem' }}
            >
                <Document
                    file={fileUrl}
                    onLoadSuccess={({ numPages }) => {
                        setNumPages(numPages);
                        // setSelectedPages(Array.from({ length: numPages }, (_, i) => i + 1)); 
                    }}
                    onLoadError={(error) => console.error('PDF load error:', error)}
                >
                    {numPages && Array.from({ length: numPages }, (_, index) => {
                        const pageNumber = index + 1;
                        const isSelected = selectedPages.includes(pageNumber);
                        console.log("Rendering page:", pageNumber, "Selected:", isSelected);

                        return (
                            <PageWrapper
                                key={`page_${pageNumber}-${isSelected}`}
                                pageNumber={pageNumber}
                                width={containerWidth}
                                isSelected={isSelected}
                                onClick={() => togglePageSelection(pageNumber)}
                            />
                        );
                    })}
                </Document>
            </div>
        </div>
    );
};
const PageWrapper = ({ pageNumber, isSelected, width, onClick }) => {
    return (
        <div className={`pdf-page-wrapper ${isSelected ? 'selected' : ''}`} onClick={onClick}>
            <Page pageNumber={pageNumber} width={width ? width - 32 : 600} renderTextLayer={false} renderAnnotationLayer={false} />
            {isSelected && <div className="pdf-page-selected-label">Geselecteerd</div>}
        </div>
    );
};